import React, { Component } from 'react';
// import 'normalize.css'
import './global.css';
import './style.css';

import ResultHeader from '../ResultHeader'
// import SurveyHeader from '../SurveyHeader'
import Survey from '../Survey'
import ResultPopup from '../ResultPopup'
import AboutPopup from '../AboutPopup'
import Introduction from '../Introduction'

import State from '../State'

// import UsefulLinks from '../UsefulLinks'

class App extends Component {

  handleAboutClick = function() {
    State.action('showAboutPopup')
  }

  render() {
    // {!State.ui.intro && !State.ui.explore ? <div className="App-survey-header"><SurveyHeader /></div> : ''}
    // {!State.ui.intro && !State.ui.explore ? <div className="App-survey-header-spacer" /> : ''}
    return (
      <div className="App">
        <div className={"app-wrapper " + (State.ui.showResultPopup || State.ui.showAboutPopup ? 'fade' : '')} >
          <div className="App-header">
            <span className="title">Moisture balance calculator</span>
            <span className="about" onClick={this.handleAboutClick}>About</span>
          </div>

          {State.ui.explore ? <div className="App-results-header"><ResultHeader /></div> : ''}

          <div className="App-body">

            {State.ui.explore ? <div className="App-results-header-spacer" /> : ''}

            <Introduction />

            <div className="App-survey">
              <Survey />
            </div>

            {/*<UsefulLinks />*/}
          </div>
        </div>

        <ResultPopup />
        <AboutPopup />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/index.js